import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Data screen imports
import { PersonalDataScreen } from '../../screens/data/PersonalDataScreen';
import { MedicalDataScreen } from '../../screens/data/MedicalDataScreen';
import { FinancialDataScreen } from '../../screens/data/FinancialDataScreen';
import { PropertyDataScreen } from '../../screens/data/PropertyDataScreen';
import { FinalWishesDataScreen } from '../../screens/data/FinalWishesDataScreen';
import { FinalCareDataScreen } from '../../screens/data/FinalCareDataScreen';
import { AllDataScreen } from '../../screens/data/AllDataScreen';

// Password management screens
import { PasswordsLockUnlockScreen } from '../../screens/tasks/passwords/PasswordsLockUnlockScreen';
import { PasswordsLockedScreen } from '../../screens/tasks/passwords/PasswordsLockedScreen';
import { PasswordsUnlockedScreen } from '../../screens/tasks/passwords/PasswordsUnlockedScreen';

const Stack = createNativeStackNavigator();

export const DataNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Data Overview Screens */}
      <Stack.Screen name="PersonalData" component={PersonalDataScreen} />
      <Stack.Screen name="MedicalData" component={MedicalDataScreen} />
      <Stack.Screen name="FinancialData" component={FinancialDataScreen} />
      <Stack.Screen name="PropertyData" component={PropertyDataScreen} />
      <Stack.Screen name="FinalWishesData" component={FinalWishesDataScreen} />
      <Stack.Screen name="FinalCareData" component={FinalCareDataScreen} />
      <Stack.Screen name="AllData" component={AllDataScreen} />

      {/* Password Management */}
       <Stack.Screen name="PasswordsLockUnlock" component={PasswordsLockUnlockScreen} options={{ headerShown: false }}/>
       <Stack.Screen name="PasswordsLocked" component={PasswordsLockedScreen} options={{ headerShown: false }}/>
       <Stack.Screen name="PasswordsUnlocked" component={PasswordsUnlockedScreen} options={{ headerShown: false }}/>
    </Stack.Navigator>
  );
};

export default DataNavigator;